import React, { useEffect, useState } from 'react';
import AppShell from '@/components/AppShell';
import client from '@/lib/api';
import { Card } from '@/components/ui/card';
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@/components/ui/table';
import { StatusBadge } from '@/components/StatusBadge';
import { Skeleton } from '@/components/ui/skeleton';

export default function Accidents() {
  const [items, setItems] = useState(null);
  useEffect(() => { client.get('/accidents').then((r) => setItems(r.data)).catch(() => setItems([])); }, []);
  return (
    <AppShell title="Accidents">
      <Card className="overflow-hidden">
        {items === null ? <div className="space-y-2 p-4">{[1,2,3].map(i=><Skeleton key={i} className="h-12" />)}</div> : items.length === 0 ? <div className="p-12 text-center text-sm text-muted-foreground">No accidents recorded.</div> : (
          <div className="overflow-x-auto"><Table>
            <TableHeader><TableRow><TableHead>Date</TableHead><TableHead>Driver</TableHead><TableHead>Location</TableHead><TableHead>Description</TableHead><TableHead>Preventable</TableHead><TableHead>Status</TableHead></TableRow></TableHeader>
            <TableBody>{items.map((it) => (
              <TableRow key={it.id}><TableCell>{it.date ? new Date(it.date).toLocaleDateString() : '-'}</TableCell><TableCell>{it.driver_name || '-'}</TableCell><TableCell>{it.location}</TableCell><TableCell>{it.description}</TableCell><TableCell>{it.preventable ? 'Yes' : 'No'}</TableCell><TableCell><StatusBadge status={it.status === 'open' ? 'pending' : 'approved'} label={it.status} /></TableCell></TableRow>
            ))}</TableBody>
          </Table></div>
        )}
      </Card>
    </AppShell>
  );
}
